import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {resolveTransactionStatusBadge, TransactionStatusBadgeVariant,} from '../../../services/vte/vte.constants';

@Component({
    selector: 'app-transaction-status-badge',
    standalone: true,
    imports: [CommonModule],
    template: `
        <span *ngIf="badge as resolved" class="transaction-status-badge" [ngClass]="resolved.variant">
            {{ resolved.label }}
        </span>
    `,
    styles: [`
        .transaction-status-badge {
            display: inline-flex;
            align-items: center;
            padding: 0.2rem 0.55rem;
            border-radius: 999px;
            font-size: 0.72rem;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            line-height: 1.2;
            white-space: nowrap;
        }

        .transaction-status-badge.created { background: #E0E7FF; color: #4338CA; }
        .transaction-status-badge.waiting { background: #DBEAFE; color: #1D4ED8; }
        .transaction-status-badge.timed_out { background: #F3F4F6; color: #6B7280; }
        .transaction-status-badge.ready { background: #E0F2FE; color: #0369A1; }
        .transaction-status-badge.inspected { background: #EDE9FE; color: #6D28D9; }
        .transaction-status-badge.actions { background: #FCE7F3; color: #BE185D; }
        .transaction-status-badge.completed { background: #DCFCE7; color: #16A34A; }
        .transaction-status-badge.neutral { background: #E5E7EB; color: #374151; }
    `],
})
export class TransactionStatusBadgeComponent {
    @Input() status: string | null | undefined = '';

    get badge(): { label: string; variant: TransactionStatusBadgeVariant } | null {
        return resolveTransactionStatusBadge(this.status);
    }
}
